export const colors = {
    adaUiGrey: "#99999",
    grey: "#EAEAEA",
    lightGrey: "#F7F7F7",
    darkGrey: "#979797",
    yellow: "#f7ce3c",

    // Theme colors
    white: "#FFFFFF",
    black: "#000000",
    blue: "#3B58F5",
    blueActive: "#7689F1",
    sky: "#80B4FF",
    purple: "#7549EA",
    midnight: "#182362",

    orange: "#FF9933",
    green: "#33CC99",
    red: "#FF4545"
};

export const borders = {
    radius: {
        small: 6,
        pill: 600,
    }
};

export const shadows = {
    default: "0px 1px 4px rgba(0, 0, 0, 0.1), 0px 0px 2px rgba(0, 0, 0, 0.1)",
    active: "0px 1px 8px rgba(0, 0, 0, 0.10), 0px 0px 8px rgba(0, 0, 0, 0.1)"
};

export const layout = {
    absoluteMaxWidth: 1920,
    siteMaxWidth: 1920,
    mainNavWidth: 1440,
    contentMaxWidth: 1100,
    marqueeContentMaxWidth: 1300,
    navContentMaxWidth: 1250,
    fluidMinWidth: 375
};

export const gutters = {
    default: { max: 50, min: 24 },
    vertical: { max: 40, min: 30 },
    verticalNarrow: { max: 45, min: 30 },
    verticalLarge: { max: 45, min: 30 },
    verticalXLarge: { max: 100, min: 50 },
    narrow: { max: 60, min: 60 },
    header: { max: 40, min: 15 },
    footer: { max: 30, min: 30 }
};

// The order of these is significant, the existing pattern should be followed
// when adding new breakpoints.
//
// - For min width, order from smallest to largest.
// - For max width, order from largest to smallest.
export const breakpoints = {
    minWidthMobileSmall: 361,
    minWidthMobile: 501,
    minWidthMobileLandscape: 581,
    minWidthTablet: 769,
    minWidthTabletLandscape: 1025,
    minWidthDesktop: 1281,
    minWidthDesktopLarge: 1441,
    minWidthLargest: 1921,

    maxWidthLargest: 1920,
    maxWidthDesktopLarge: 1440,
    maxWidthDesktop: 1280,
    maxWidthTabletLandscape: 1024,
    maxWidthTablet: 768,
    maxWidthMobileLandscape: 580,
    maxWidthMobile: 500,
    maxWidthMobileSmall: 360
};

export const breakpointOrder = Object.keys(breakpoints);
